import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { format } from "date-fns";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Formata uma data (YYYY-MM-DD) para o padrão brasileiro (dd/MM/yyyy)
 * ajustando o timezone para o meio do dia para evitar problemas de offset
 * na exportação e exibição.
 */
export function formatarDataIsoParaBr(dataIso: string | null | undefined): string {
  if (!dataIso) return "—";
  try {
    // Se for apenas data (YYYY-MM-DD), ajusta para o meio do dia para evitar problemas de timezone
    if (dataIso.length === 10) {
      return format(new Date(dataIso + 'T12:00:00'), 'dd/MM/yyyy');
    }
    // Para ISO completo (timestamp), usa o Date nativo que já lida com o fuso local
    return format(new Date(dataIso), 'dd/MM/yyyy');
  } catch (error) {
    console.error("Erro ao formatar data:", error);
    return "—";
  }
}
